export default __webpack_public_path__ + "static/media/Thumbs.1697826d.db";